



































































































































































































































































































































































































































































































































































































































































































































































































































































































import BraintreeDropin from 'braintree-web-drop-in';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { ClientSubscription, ClientSubscriptionStatus } from '@/models/payment/PaymentMethods';
import SubscriptionPlan from '@/models/payment/SubscriptionPlan';
import Coupon from '@/models/payment/Coupon';
import User from '@/models/User';
import DropinContainer from './DropinContainer.vue';
import PaymentMethodManager from './PaymentMethodManager.vue';
import PaymentPlanComponent from './PaymentPlan.vue';
import PaymentMethodSelect from './SubPanelPaymentMethods.vue';

@Component({
    components: 
    {
        PaymentPlanComponent,
        DropinContainer,
        PaymentMethodSelect,
        PaymentMethodManager
    }
})
export default class SubscriptionPanel extends Vue 
{
    @Prop(Boolean) readonly project! : Boolean; // default false
    @Prop(String) readonly pid! : String;
    @Prop(Function) readonly doSubscribe! : Function;
    @Prop(Function) readonly onSubscribe! : Function;
    /** if different from onSubscribe */
    @Prop(Function) readonly onTerminate! : Function;
    @Prop(SubscriptionPlan) readonly startingSelectedPlan?: SubscriptionPlan;
    
    customerForm =
    {
        firstName: "",
        lastName: ""
    }
    
    dropin : BraintreeDropin.Dropin | undefined | null = null
    hasLoadedPlans = false
    plans : SubscriptionPlan[] = []
    hasLoadedSubscriptions = false
    subscriptions : ClientSubscription[] = []
    subOwner : { firstName : string, lastName : string, id : string } | null = null
    selectedPlan : SubscriptionPlan | null = null
    loadCount = 0;
    paymentMethod : {type : string, details : object, nonce : string} | null = null
    creatingSubscription = false;
    selectedTier = 1;
    tiers = [
        { text: '20 Members', value: 1},
        { text: '50 Members', value: 2},
        { text: '100 Members', value: 3},
        { text: '250 Members', value: 4}
    ];
    users : {premium: boolean}[] | null = null;
    freeUserBudget = 0;
    trialMode = false;
    appliedCoupon : Coupon | null = null;
    couponToApply : Coupon | null = null;
    codeInput : string = '';
    couponApplying = false;

    get eduDiscountCode()
    {
        return '.edu-discount!';
    }

    get shouldDisableSubscribeButtons()
    {
        return this.creatingSubscription || this.isRefreshingUser || this.loadCount > 0;
    }

    get freeUserCount()
    {
        let count = 0;
        if (this.users != null)
        {
            for (let i = 0; i < this.users.length; ++i)
            {
                if (!(this.users[i].premium))
                {
                    ++count;
                }
            }
        }
        return count;
    }

    doOnEnter(event : KeyboardEvent, doThing : Function)
    {
        if (event.key == "Enter")
        {
            doThing();
        }
    }

    loadUserData()
    {
        this.$set(this, "users", null);            
        this.$http.get("viewprojectusers?pid=" + this.pid)
            .then(
                (resp)=>
                {
                    this.$set(this, "users", resp.data.users);
                },
                (error)=>
                {
                    console.error(error.response);
                });
        this.loadFreeUserBudget();
    }

    loadFreeUserBudget()
    {      
        this.$http.get("projects/freeuserbudget?projectid=" + this.pid)
            .then(
                (resp) =>
                {
                    this.$set(this, "freeUserBudget", resp.data.budget);
                },
                (error) =>
                {
                    console.error(error.response);
                });
    }

    get shouldGetEduDiscount()
    {
        return this.user.eduEligibilityOverride || this.user.email.endsWith('.edu');
    }

    get expirationDisplay()
    {
        if (this.user.trialExpiration != null)
        {
            return this.user.trialExpiration.toLocaleString();
        }
        else
        {
            let exp = new Date();
            exp.setDate(exp.getDate() + 30);
            return exp.toLocaleString();
        }
    }

    get canTrial()
    {
        return this.user.trialing // you can implicitly trial if you are trialing
            || (!(this.isSubscribed) && this.user.trialExpiration == null);
        // otherwise you should not be subscribed nor should you have previously trialed
    }

    async startTrial()
    {
        this.loading = true;
        try
        {
            if (!(this.project))
            {
                await this.$http.post(`trial/start`);

                if (this.onSubscribe != null)
                {
                    await Promise.resolve(this.onSubscribe());
                }
            }
        }
        catch (er)
        {
            if (er.response && er.response.data && er.response.data.error)
            {
                this.errors.length = 0;
                this.errors.push({error: er.response.data.error});
            }
            else
            {
                alert(`Error while starting trial`);
                console.error(er);
                this.$router.go(0);
                throw er;
            }
        }
        this.hasLoadedPlans = false;
        this.plans = [];
        this.hasLoadedSubscriptions = false;
        this.subscriptions = [];
        this.paymentMethod = null;
        this.selectedPlan = null;
        
        if (!(this.project))
        {
            // bc this function could change user.isSubscribed, refetch cached user
            await this.refetchUser();
        }
        
        await this.refreshish();
        this.loading = false;
    }

    get loading()
    {
        return this.loadCount > 0;
    }

    set loading(value : boolean)
    {
        if (value)
        {
            //console.error('incr');
            ++(this.loadCount);
        }
        else
        {
            //console.error('decr');
            if (this.loadCount > 0)
            {
                --(this.loadCount);
            }
            else
            {
                this.loadCount = 0;
            }
        }
    }

    errors : {error : string}[] = [];
    customer_data: any | null = null

    get isSubscribed()
    {
        return this.user.isSubscribed;
    }

    get ownsActiveSubscription()
    {
        if (this.customer_data != null)
        {
            return this.subOwner == null || this.customer_data.id == this.subOwner.id;
        }
        return false;
    }

    get activeSubscription()
    {
        for (let sub of this.subscriptions)
        {
            if (sub.status != ClientSubscriptionStatus.Active) continue;
            return sub;
        }
        return null;
    }

    get activeSubPlan()
    {
        let sub = this.activeSubscription;
        if (sub == null)
        {
            return null;
        }

        for(let plan of this.plans)
        {
            if (plan.id == sub.planId)
            {
                return plan;
            }
        }
        return null;
    }

    get discountedPrice()
    {
        if (this.selectedPlan == null)
        {
            return 0;
        }
        else if (this.appliedCoupon == null)
        {
            return this.selectedPlan.price;
        }
        else if (this.appliedCoupon.percentage)
        {
            return Math.min(this.selectedPlan.price, 
                Math.max(0, this.selectedPlan.price * (1.0 - (this.appliedCoupon.value / 100.0))));
        }
        else
        {
            return Math.min(this.selectedPlan.price, 
                Math.max(0, this.selectedPlan.price - this.appliedCoupon.value));
        }
    }

    get potentialDiscountedPrice()
    {
        if (this.selectedPlan == null)
        {
            return 0;
        }
        else if (this.couponToApply == null)
        {
            return this.selectedPlan.price;
        }
        else if (this.couponToApply.percentage)
        {
            return Math.min(this.selectedPlan.price, 
                Math.max(0, this.selectedPlan.price * (1.0 - (this.couponToApply.value / 100.0))));
        }
        else
        {
            return Math.min(this.selectedPlan.price, 
                Math.max(0, this.selectedPlan.price - this.couponToApply.value));
        }
    }

    get renderedPrice()
    {
        return ((Math.ceil(this.discountedPrice * 100) / 100).toFixed(2));
    }

    get renderedDiscount()
    {
        return `- ${(this.appliedCoupon != null) 
            ? (this.appliedCoupon.percentage) 
                ? `${this.appliedCoupon.value}%` 
                : `$${(Math.ceil((this.appliedCoupon.value) * 100) / 100).toFixed(2)}` 
            : ''}`;
    }

    get undiscountedRenderedPrice()
    {
        return (this.selectedPlan != null) 
            ? ((Math.ceil(this.selectedPlan.price * 100) / 100).toFixed(2)) 
            : '';
    }

    get selectedBillingCycleText()
    {
        if (this.selectedPlan == null)
        {
            return '';
        }
        else if (this.selectedPlan.billingCycle === 1)
        {
            return 'monthly';
        }
        else
        {
            return `every ${this.selectedPlan.billingCycle} months`;
        }
    }

    get filteredPlans()
    {
        return this.plans.filter((p) => (!(this.project) || p.id.includes(`tier${this.selectedTier}`)) && (this.activeSubPlan == null || p.id !== this.activeSubPlan.id));
    }

    async onMethodUpdate()
    {
        if (this.pid != null && this.pid !== '')
        {
            const respCust = await this.$http.get<
                { 
                    firstName : string, 
                    lastName : string, 
                    id : string 
                }
                >(`payments/customer/searchbysub/${this.pid}`);
            this.$set(this, 'subOwner', respCust.data);
        }
        else
        {
            this.$set(this, 'subOwner', null);
        }
    }

    async applyCoupon()
    {
        this.couponApplying = true;
        try
        {
            const coupon = (await this.$http.get<Coupon>(`coupons/${this.codeInput}`)).data;
            if (coupon.code
                && ((coupon.forProjects && this.project) || (coupon.forUsers && !(this.project)))
                && (this.shouldGetEduDiscount || coupon.code !== this.eduDiscountCode)
                && (coupon.maxUses === 0 || coupon.uses < coupon.maxUses))
            {
                if (this.appliedCoupon != null)
                {
                    this.$set(this, 'couponToApply', coupon);
                    if (this.potentialDiscountedPrice <= this.discountedPrice)
                    {
                        this.confirmCoupon();
                    }
                    else
                    {
                        (this.$refs.confirmCouponModal as any).show();
                    }
                }
                else
                {
                    this.$set(this, 'appliedCoupon', coupon);
                }
            }
            else
            {
                this.$bvToast.toast('Coupon code invalid.', { variant: 'danger' });
            }
        }
        catch (err)
        {
            console.error(err);
            this.$set(this, 'appliedCoupon', null);
            this.$bvToast.toast('Coupon code invalid.', { variant: 'danger' });
        }
        this.couponApplying = false;
    }

    confirmCoupon()
    {
        this.$set(this, 'appliedCoupon', this.couponToApply);
        this.$set(this, 'couponToApply', null);
    }

    async applyEduDiscount(suppressToast = false)
    {
        if (this.shouldGetEduDiscount)
        {
            this.codeInput = this.eduDiscountCode;
            await this.applyCoupon();
            this.codeInput = '';
        }
        else if (!suppressToast)
        {
            this.$bvToast.toast('Not eligible for edu discount.', { variant: 'danger' });
        }
    }

    removeCoupon()
    {
        this.$set(this, 'appliedCoupon', null);
    }

    async renewSubscription()
    {
        this.loading = true;
        try
        {
            if (this.project)
            {
                if (this.pid)
                {
                    await this.$http.post(`payments/subscription/renew/${this.pid}`);
                }
            }
            else
            {
                await this.$http.post('payments/subscription/renew');
            }
        }
        catch (er)
        {
            if (er.response && er.response.data && er.response.data.error)
            {
                this.errors.length = 0;
                this.errors.push({error: er.response.data.error});
            }
            else
            {
                alert('Error while renewing subscription');
                console.error(er);
                this.$router.go(0);
                throw er;
            }
        }
        this.hasLoadedPlans = false;
        this.plans = [];
        this.hasLoadedSubscriptions = false;
        this.subscriptions = [];
        await this.refreshish();
        this.loading = false;
    }

    async cancelSubscription()
    {
        this.loading = true;
        try
        {
            if (this.project)
            {
                if (this.pid)
                {
                    await this.$http.post(`payments/subscription/cancel/${this.pid}`);
                }
            }
            else
            {
                await this.$http.post('payments/subscription/cancel');
            }
        }
        catch (er)
        {
            if (er.response && er.response.data && er.response.data.error)
            {
                this.errors.length = 0;
                this.errors.push({error: er.response.data.error});
            }
            else
            {
                alert('Error while canceling subscription');
                console.error(er);
                this.$router.go(0);
                throw er;
            }
        }
        this.hasLoadedPlans = false;
        this.plans = [];
        this.hasLoadedSubscriptions = false;
        this.subscriptions = [];
        this.paymentMethod = null;
        this.selectedPlan = null;

        if (!(this.project))
        {
            // bc this function could change user.isSubscribed, refetch cached user
            await this.refetchUser();
        }

        await this.refreshish();
        this.loading = false;
    }

    async terminateSubscription()
    {
        this.loading = true;
        try
        {
            if (this.project)
            {
                if (this.pid)
                {
                    await this.$http.post(`payments/subscription/terminate/${this.pid}`);

                    if (this.onTerminate != null)
                    {
                        await Promise.resolve(this.onTerminate());
                    }
                    else if (this.onSubscribe != null)
                    {
                        await Promise.resolve(this.onSubscribe());
                    }
                }
            }
        }
        catch (er)
        {
            if (er.response && er.response.data && er.response.data.error)
            {
                this.errors.length = 0;
                this.errors.push({error: er.response.data.error});
            }
            else
            {
                alert('Error while terminating subscription');
                console.error(er);
                this.$router.go(0);
                throw er;
            }
        }
        this.hasLoadedPlans = false;
        this.plans = [];
        this.hasLoadedSubscriptions = false;
        this.subscriptions = [];
        this.paymentMethod = null;
        this.selectedPlan = null;
        
        if (!(this.project))
        {
            // bc this function could change user.isSubscribed, refetch cached user
            await this.refetchUser();
        }
        
        await this.refreshish();
        this.loading = false;
    }

    async validateUserExists()
    {
        let oldLoad = this.loading;
        this.loading = true;
        try
        {
            let resp = await this.$http.get("payments/customer");
            this.$set(this, 'customer_data', resp.data.customer);
            return true;
        }
        catch(er)
        {
            if (er.response.status != 404)
            {
                console.error(er);
                throw er;
            }
        }
        finally
        {
            this.loading = false;
        }
        return false;
    }

    async updateCustomerForm()
    {
        try
        {
            await this.$http.put('payments/customer', this.customerForm);
        }
        catch (er)
        {
            console.error(er);
            this.errors.length = 0;
            this.errors.push({error: "Failed to update customer info"});
            this.loading = false;
        }

        await this.refreshish();
    }

    async loadActiveSub(refresh = false)
    {
        if (refresh)
        {
            this.hasLoadedSubscriptions = false;
        }

        if (this.hasLoadedSubscriptions)
        {
            return;
        }

        this.loading = true;
        try
        {
            this.subscriptions.length = 0;
            if (this.project)
            {
                if (this.pid)
                {
                    const respSub = await this.$http.get<
                        {
                            subscription : 
                            {
                                planId : string, 
                                nextBillingDateStr : string, 
                                paidThroughDateStr : string, 
                                status : ClientSubscriptionStatus, 
                                nextBillAmount : number, 
                                expiring : boolean
                            }
                        }
                        >(`payments/subscription/${this.pid}`);
                    this.subscriptions.push(new ClientSubscription(respSub.data.subscription));
                    const respCust = await this.$http.get<
                        { 
                            firstName : string, 
                            lastName : string, 
                            id : string 
                        }
                        >(`payments/customer/searchbysub/${this.pid}`);
                    this.$set(this, 'subOwner', respCust.data);
                }
            }
            else
            {
                const resp = await this.$http.get<
                    {
                        subscriptions : 
                        {
                            planId : string, 
                            nextBillingDateStr : string, 
                            paidThroughDateStr : string, 
                            status : ClientSubscriptionStatus, 
                            nextBillAmount : number, 
                            expiring : boolean
                        }[]
                    }
                    >('payments/subscription/active');
                const ps = resp.data.subscriptions;
                for (const sub of ps)
                {
                    if (sub.planId.startsWith("project"))
                    {
                        continue;
                    }
                    this.subscriptions.push(new ClientSubscription(sub));
                }
                this.$set(this, 'subOwner', null);
            }
            
            if (this.project && this.pid)
            {
                this.loadFreeUserBudget();
            }
            
            this.hasLoadedSubscriptions = true;
        }
        catch (er)
        {
            this.errors.length = 0;
            this.errors.push({error: "Failed to update customer info"});
            this.loading = false;
            console.error(er);
            return false;
        }
        return true;
    }

    async loadPlans(refresh = false)
    {
        if (refresh)
        {
            this.hasLoadedPlans = false;
        }
        if (this.hasLoadedPlans)
        {
            return true;
        }

        this.loading = true;
        try
        {
            let resp = await this.$http.get<{plans : SubscriptionPlan[]}>('payments/subscription/plans');
            let ps = resp.data.plans;
            this.plans.length = 0;
            for (let p of ps)
            {
                const plan = Object.assign(new SubscriptionPlan(), p);
                if (plan.id.startsWith('project'))
                {
                    if (this.project)
                    {
                        this.plans.push(plan); // project plans
                    }
                }
                else if (!(this.project))
                {
                    this.plans.push(plan); // individual plans
                }
            }
            this.plans.sort((a, b) => a.billingCycle - b.billingCycle);
            this.hasLoadedPlans = true;
        }
        catch (er)
        {
            this.errors.length = 0;
            this.errors.push({error: "Failed to update customer info"});
            this.loading = false;
            console.error(er);
            return false;
        }
        return true;
    }

    async refreshish()
    {
        if (this.canTrial && this.selectedPlan == null)
        {
            this.trialMode = true;
        }

        if (!await this.loadPlans())
        {
            this.loadCount = 0;
            return;
        }

        if (!await this.validateUserExists())
        {
            this.loadCount = 0;
        }

        if (this.user.isSubscribed || this.project)
        {
            let msubWait = await this.loadActiveSub();
            this.loadCount = 0;
            return;
        }
        
        this.loadCount = 0;
    }

    async confirmChangePlan()
    { 
        await this.createSubscription(true);
        (this.$refs.changePlanModal as any).hide();
    }

    async createSubscription(tryCancelFirst : boolean = false)
    {
        if (this.paymentMethod == null)
        {
            alert('No payment selected');
            return;
        }

        if (this.selectedPlan == null)
        {
            alert('No plan selected');
            return;
        }
        
        try
        {
            this.creatingSubscription = true;
            const request = {
                nonce: this.paymentMethod.nonce,
                planID: this.selectedPlan.id,
                id: this.project ? this.pid : null,
                tryCancelFirst,
                coupon: this.appliedCoupon ? this.appliedCoupon.code : null,
            };
            if (this.doSubscribe != null)
            {
                await Promise.resolve(this.doSubscribe(request));
            }
            else
            {
                if (!(this.project) || this.pid)
                {
                    await this.$http.post('payments/subscription', request);
                }
            }
            if (this.onSubscribe != null)
            {
                await Promise.resolve(this.onSubscribe());
            }
            this.paymentMethod = null;
            this.selectedPlan = null;
        }
        catch (er)
        {
            if (!er)
            {
                console.error("Well this shouldn't be possible");
            }
            else
            {
                console.error(er);
                alert(er);
            }
        }
        this.hasLoadedPlans = false;
        this.plans = [];
        this.hasLoadedSubscriptions = false;
        this.subscriptions = [];
        
        if (!(this.project))
        {
            // bc this function could change user.isSubscribed, refetch cached user
            await this.refetchUser();
        }

        await this.refreshish();
        
        this.creatingSubscription = false;
    }

    isRefreshingUser = false;
    async refetchUser()
    {
        try
        {
            this.isRefreshingUser = true;
            const resp = await Vue.axios.get('userinfo');
            if (resp != null && resp.data.user != null)
            {
                this.$store.commit('setUserData', resp.data.user);
            }
            else
            {
                this.$router.go(0); // refresh page
            }
        }
        finally
        {
            this.isRefreshingUser = false;
        }
    }

    onPaymentSelected(payment : any)
    {
        this.paymentMethod = payment;
    }

    async mounted()
    {
        if (this.startingSelectedPlan)
        {
            this.selectedPlan = this.startingSelectedPlan;
        }
        
        await this.refreshish();

        if (this.project && this.pid)
        {
            this.loadUserData();
        }

        await this.applyEduDiscount(true);
    }
}
